export default "__VITE_ASSET__743ca89f__"